import generateID from '@/utils/generate-id';
import { buildAstState } from '..';
import { getRefName } from './name.utils';
import { addResourceIfNotExists } from './resource.utils';

const _createDefaultBgImageAst = (resourceAst: Ast) => {
  const ast: Ast = {
    tag: 'Image',
    attrsMap: {
      src: '_defaultBg.png',
      compressMethod: buildAstState.data.compressMethod,
      format: buildAstState.data.imageFormatDefault
    },
    children: []
  };
  return addResourceIfNotExists(resourceAst, ast);
};

// 添加默认背景图
const _addAsLayoutImage = (themeAst: Ast, resourceAst: Ast) => {
  const ast2 = _createDefaultBgImageAst(resourceAst);
  // 在第一个theme下增加一个layout
  themeAst.children.unshift({
    tag: 'Layout',
    attrsMap: {
      ref: getRefName(ast2.attrsMap.name),
      x: '0',
      y: '0',
      _id: generateID(),
      _name: '默认背景图-工具添加'
    },
    children: []
  });
};

const _addAsBgAttr = (themeAst: Ast, resourceAst: Ast) => {
  const ast2 = _createDefaultBgImageAst(resourceAst);
  if (ast2) {
    const name = getRefName(ast2.attrsMap.name);
    themeAst.attrsMap.bg = name;
    themeAst.children.unshift({
      tag: 'Layout',
      attrsMap: {
        ref: name,
        x: '0',
        y: '0',
        _id: generateID(),
        _name: '默认背景图-工具添加'
      },
      children: []
    });
    delete themeAst.attrsMap.bgColor;
  }
};

export const addThemeDefaultBg = (themeAst: Ast, resourceAst: Ast) => {
  const themeType = themeAst.attrsMap.type;
  // 如果是AOD，则直接添加bg属性上，否则添加layout
  if (themeType === 'AOD') {
    _addAsBgAttr(themeAst, resourceAst);
  } else {
    _addAsLayoutImage(themeAst, resourceAst);
  }
};
